import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';

import { Flexed, TabSelectButton, Tabs } from '../../styles/GlobalComponents';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router';
import { MY_TICKETS, MY_TICKETS_WEBINAR_TICKETS } from '../../routes/routes';

import { BigWhaleSummary } from '../Portfolio/BigWhaleSummary';
import { TicketSummary } from './TicketSummary';

export const WebinarTickets = () => {
  const dispatch = useAppDispatch();

  const { loading, loadingHubs } = useAppSelector((state) => state.portfolio);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // dispatch(getMyHubsSummary());
    // dispatch(getMyHubsPowerPack());
  }, [dispatch]);

  const pathname = location.pathname;

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom>
      {loadingHubs && <Spinner fullScreen={true} transparent />}

      <Switch location={location} key={location.pathname}>
        <Route path={MY_TICKETS}>
          <TicketSummary />
        </Route>
      </Switch>
    </AnimatedDashboard>
  );
};
